import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';

import MallaForm from './MallaForm';
import {
  get,
  save,
  fetchFormDatas,
} from '../../../redux/actions/mallaActions';
import {
  remove as removeMateriaMalla,
} from '../../../redux/actions/materiaMallaActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import Confirm from '../../../shared/components/Confirm';

class MallaFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.handleOnSubjectChange = this.handleOnSubjectChange.bind(this);
    this.handleDeleteMateriaMalla = this.handleDeleteMateriaMalla.bind(this);
  }

  componentDidMount() {
    this.fetchDatasList();
    this.fetchCurrentRecord();
  }

  fetchCurrentRecord = () => {
    const { id, history } = this.props;
    if (id) {
      get(id, {
        onSuccess: (dto) => {
          const malla = {
            ...dto,
            carrera: {
              value: dto.carreraId,
              label: dto.carrera,
            },
          };

          this.setState({ malla });
        },
        onError: (error) => {
          if (error && error.status === 404) {
            createErrorMessage('El malla no existe');
            history.push('/pages/mallas');
          } else {
            createErrorMessage('Error al intentar cargar los datos de la malla');
          }
        },
      });
    } else {
      this.setState({
        malla: {
          id: 0,
          fecha: new Date().toISOString(),
        },
      });
    }
  }

  fetchDatasList = () => {
    fetchFormDatas({
      onSuccess: (d) => {
        this.setState({
          carreras: d.carreras,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    const { carrera: { value: carreraId } } = values;
    const params = {
      ...values,
      carreraId,
    };

    const { history } = this.props;
    save(params, {
      onSuccess: () => {
        createSuccessMessage('Malla guardada exitosamente');
        history.push('/pages/mallas');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la malla');
        }
      },
    });
  }

  handleDeleteMateriaMalla = (materiaMalla) => {
    const name = `${materiaMalla.materia}`;
    Confirm({
      title: 'Quitar materia de malla',
      question: `Estás seguro que deseas quitar la materia ${name} de esta malla?`,
      yesLabel: 'Si, Quitar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        removeMateriaMalla(materiaMalla.id, {
          onSuccess: () => {
            createSuccessMessage('Materia quitada exitosamente');
            this.fetchDatasList();
            this.fetchCurrentRecord();
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La materia no existe');
            } else {
              createErrorMessage('Error al intentar quitar la materia de la malla');
            }
          },
        });
      },
    });
  };

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    const { malla } = this.state;
    this.setState({
      [idKey]: value.value,
      malla: { ...malla, [objectKey]: value },
    });
  }

  handleOnSubjectChange = (objectKey, idKey, value) => {
    const { malla } = this.state;
    const profesor = `${value.nombre} ${value.apellido}`;
    let { interventorId, interventor } = malla;

    if (!interventorId) {
      interventorId = value.usuarioId;
      interventor = { value: interventorId, label: profesor };
    }
    this.setState({
      [idKey]: value.value,
      malla: {
        ...malla,
        [objectKey]: value,
        profesor,
        interventor,
        interventorId,
      },
    });
  }

  render() {
    const { id, history } = this.props;
    const {
      malla,
      carreras,
    } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} malla
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n de la malla
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(carreras)
              ? (<h3 className="page-subhead subhead">Cargando...</h3>)
              : (
                <MallaForm
                  {...malla}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={malla}
                  history={history}
                  carreras={carreras}
                  onFilterChanges={this.handleOnFilterChange}
                  onSubjectChanges={this.handleOnSubjectChange}
                  handleDeleteMateriaMalla={this.handleDeleteMateriaMalla}
                  enableReinitialize
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

MallaFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default MallaFormContainer;
